import { useEffect } from 'react';
import { selectors, useGetProjectChartQuery } from 'app/services/projects';
import { useSelector } from 'react-redux';
import { Empty, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { buildMeasurementsChart } from 'utils/chart';

import './chart.less';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import ChartWarning from './ChartWarning';

type ChartWrapperProps = {
  id: string;
  isInteractive?: boolean;
};

const ChartWrapper = ({ id, isInteractive }: ChartWrapperProps) => {
  const project = useSelector(selectors.getProject);
  const { data, isFetching, isLoading } = useGetProjectChartQuery(project?.Id || skipToken);
  const hasMeasurements = data?.Measurements && data.Measurements.length > 0;
  const isInteractiveMode = typeof isInteractive === 'boolean' ? isInteractive : true;

  if (isFetching || isLoading) return <div className='chart-placeholder'>
    <Spin size='large' />
  </div>;

  if (data && !hasMeasurements) return (
    <>
      <ChartWarning warnings={data?.Warnings}/>
      <div className='chart-placeholder'>
        <Empty />
      </div>
    </>
  );

  if (!data) return <div className='chart-placeholder'>
    <Empty />
  </div>;

  return (
    <>
      <ChartWarning warnings={data.Warnings}/>
      <Chart data={data} id={id} isInteractive={isInteractiveMode} />
    </>
  );
};

const Chart = ({ data, id, isInteractive }: { data: any, id: string, isInteractive: boolean }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const root = buildMeasurementsChart(data, t, id, { isInteractive });
    return () => { root.dispose(); };
  }, [ data, t, id, isInteractive ]);

  return <div className='chart-wrapper' id={id}></div>;
};

export default ChartWrapper;